module.exports = __webpack_public_path__ + "img/P150T_weapon_57.35d67e41.png";